import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "absolute inset-0 flex w-full h-full rounded-full cursor-pointer" }
const _hoisted_2 = {
  key: 0,
  class: "absolute inset-0 w-full h-full overflow-hidden rounded-full"
}
const _hoisted_3 = { class: "flex items-center justify-center w-full h-full rounded-full" }
const _hoisted_4 = {
  key: 0,
  class: "absolute top-0 left-0 flex items-center justify-center w-full h-full text-xl font-semibold text-gray-500"
}
const _hoisted_5 = {
  key: 1,
  class: "absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold text-gray-500" }, " 100% ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500" }, "Processing", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "absolute inset-0 w-full h-full overflow-hidden transition bg-opacity-0 rounded-full pointer-events-none group-hover:bg-gray-800 group-hover:bg-opacity-50"
}
const _hoisted_10 = { class: "flex items-center justify-center w-full h-full rounded-full" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageIcon = _resolveComponent("ImageIcon")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_CameraIcon = _resolveComponent("CameraIcon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.element), _mergeProps(_ctx.$attrs, {
    tabindex: _ctx.interactive || _ctx.editable ? 0 : '',
    "aria-label": "Profile icon",
    class: ["flex items-center transition border-4 rounded-full focus:outline-none", {
      'border-white': !_ctx.adminTakover,
      'border-orange-400': _ctx.adminTakover,
      'cursor-pointer': _ctx.interactive,
      'focus:ring-2 focus:ring-offset-2': (_ctx.interactive || _ctx.editable),
      'focus:ring-blue-300 focus:ring-offset-blue-50': (_ctx.interactive || _ctx.editable) && !_ctx.inverse,
      'focus:ring-white focus:ring-opacity-50': (_ctx.interactive || _ctx.editable) && _ctx.inverse,
      'focus:ring-offset-gray-800': (_ctx.interactive || _ctx.editable) && _ctx.inverse && _ctx.color === 'gray',
      'focus:ring-offset-blue-500': (_ctx.interactive || _ctx.editable) && _ctx.inverse && _ctx.color === 'blue',
      'focus:ring-offset-green-400': (_ctx.interactive || _ctx.editable) && _ctx.inverse && _ctx.color === 'green',
      'focus:ring-offset-orange-500': (_ctx.interactive || _ctx.editable) && _ctx.inverse && _ctx.color === 'orange',
    }]
  }), {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["relative overflow-hidden rounded-full", {
        'bg-gray-200': _ctx.isPrivateNow || !_ctx.icon,
        'bg-white': !_ctx.isPrivateNow && _ctx.icon,
        'pl-[1px] m-[-1px]': !_ctx.isPrivateNow && _ctx.icon && (_ctx.size === 'lg' || _ctx.size === 'md'),
        'w-32 h-32 min-w-32 min-h-32 border border-gray-100': _ctx.size === 'lg',
        'w-24 h-24 min-w-24 min-h-24 border border-gray-100': _ctx.size === 'md',
        'w-14 h-14 min-w-14 min-h-14 border border-gray-100': _ctx.size === 'sm',
        'w-8  h-8  min-w-8  min-h-8  border border-gray-100': _ctx.size === 'xs',
        'group': _ctx.editable,
      }])
      }, [
        (!_ctx.editable)
          ? (_openBlock(), _createBlock(_component_ImageIcon, {
              key: 0,
              icon: _ctx.isPrivateNow ? null : _ctx.icon,
              size: _ctx.size,
              alt: _ctx.mode === 'profile' ? `Profile icon` : `Company icon`,
              placeholder: _ctx.mode,
              lazy: _ctx.lazy
            }, null, 8, ["icon", "size", "alt", "placeholder", "lazy"]))
          : (_openBlock(), _createElementBlock("form", {
              key: 1,
              enctype: "multipart/form-data",
              action: "",
              novalidate: "",
              autocomplete: "off",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("label", _hoisted_1, [
                _createVNode(_component_ImageIcon, {
                  icon: _ctx.icon,
                  size: _ctx.size,
                  alt: `Icon`,
                  placeholder: _ctx.mode
                }, null, 8, ["icon", "size", "placeholder"]),
                _createVNode(_Transition, {
                  "enter-active-class": "duration-300 ease-out",
                  "enter-from-class": "scale-50 opacity-0",
                  "enter-to-class": "scale-100 opacity-100",
                  "leave-active-class": "durat3on-200 ease -in",
                  "leave-from-class": "scale-100 opacity-100",
                  "leave-to-class": "scale-50 opacity-0"
                }, {
                  default: _withCtx(() => [
                    (_ctx.uploadingPhoto)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                          _createElementVNode("span", _hoisted_3, [
                            _createVNode(_component_LoadingSpinner, { class: "w-full h-full m-0 mx-auto my-1 mt-0 bg-white bg-opacity-75" })
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "duration-300 ease-in",
                            "enter-from-class": "scale-50 opacity-0",
                            "enter-to-class": "scale-100 opacity-100",
                            "leave-from-class": "scale-100 opacity-100",
                            "leave-to-class": "scale-50 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.uploadingPercentage !== 100)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.uploadingPercentage) + "% ", 1))
                                : (_ctx.uploadingPercentage === 100)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
                                  : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, [
                            _createVNode(_component_CameraIcon, {
                              "aria-hidden": "true",
                              class: "flex w-2/5 text-white text-opacity-0 transition group-hover:text-opacity-50 h-2/5"
                            })
                          ])
                        ]))
                  ]),
                  _: 1
                }),
                _createElementVNode("input", {
                  type: "file",
                  disabled: _ctx.uploadingPhoto,
                  name: "photo",
                  accept: ".png, .jpg, .webp",
                  class: "absolute z-0 w-0 h-0 opacity-0",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectPhoto && _ctx.selectPhoto(...args)))
                }, null, 40, _hoisted_11)
              ])
            ], 32))
      ], 2)
    ]),
    _: 1
  }, 16, ["tabindex", "class"]))
}